import { render } from "./myjifen.vue?vue&type=template&id=0d944603&scoped=true"
import script from "./myjifen.vue?vue&type=script&lang=js"
export * from "./myjifen.vue?vue&type=script&lang=js"

import "./myjifen.vue?vue&type=style&index=0&id=0d944603&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d944603"]])

export default __exports__